import "./TextInput.css";

const TextInput = ({ value, callbackOnChange, callbackOnKeyDown, placeholder, maxLength }) => {
  return (
    <input
      type="text"
      className="word-input"
      value={value}
      onChange={callbackOnChange}
      onKeyDown={callbackOnKeyDown}
      placeholder={placeholder}
      maxLength={maxLength}
    />
  );
};

export { TextInput };
